import { trigger, animate, transition, style } from '@angular/animations';

export const height =
    trigger('height', [
        // route 'enter' transition
        transition(':enter', [
            // styles at start of transition
            style({
                opacity: 0,
                height: 0
             }),
            // animation and styles at end of transition
            animate('.75s ease-in-out', style({
                opacity: 1,
                height: '*'
             }))
        ]),
        // route 'leave' transition
        transition(':leave', [
            // styles at start of transition
            style({
                opacity: 1
            }),
            // animation and styles at end of transition
            animate('.5s ease-in-out', style({
                opacity: 0,
                height: 0
            }))
        ]),
    ]);
